import { getFieldValues } from "../../actions/HomeAction";
import React, { useEffect, useRef, useState } from "react";
import { Header } from "../../components/SpearParts/Layouts/Header";
import { SeachSection } from "../../components/SpearParts/Layouts/SeachSection";
import {
  searchPart,
  getCompleteData,
  getItems,
} from "../../actions/HomeAction";
import { Link, useLocation } from "react-router-dom";
import Advancedfilter from "../AdvancedFilter/Advancedfilter";
import NoData from "../../components/NoData/Index";
import { toTitleCase } from "../../components/utils/StringUtil";

export const ProductCategory = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const yearRef = useRef(null);

  const [parts, setParts] = useState([]);
  const [spareCategory, setSpareCategory] = useState([]);
  const [spareBrand, setSpareBrand] = useState([]);
  const [spareModels, setSpareModels] = useState([]);
  const [region, setRegion] = useState([]);
  const [years, setYears] = useState([]);

  const [yearOptions, setYearOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [steeringOptions, setSteeringOptions] = useState([]);
  const [bodyTypeOptions, setBodyTypeOptions] = useState([]);
  const [transmissionOptions, setTransmissionOptions] = useState([]);
  const [modificationOptions, setModificationOptions] = useState([]);
  const [engineOptions, setEngineOptions] = useState([]);
  const [engineCodeOptions, setEngineCodeOptions] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);

  useEffect(() => {
    getFieldValues().then((data) => {
      setYearOptions(data.years || []);
      setRegionOptions(data.regions || []);
      setSteeringOptions(data.steering || []);
      setBodyTypeOptions(data.bodyTypes || []);
      setTransmissionOptions(data.transmissionTypes || []);
      setModificationOptions(data.modifications || []);
      setEngineOptions(data.engines || []);
      setEngineCodeOptions(data.engineCodes || []);
      setGradeOptions(data.grades || []);
    });
  }, []);

  useEffect(() => {
    if (location.state) {
      setSpareCategory(location.state.spareCategory || []);
      setSpareBrand(location.state.spareBrand || []);
      setSpareModels(location.state.spareModels || []);
      setRegion(location.state.region || []);
      setYears(location.state.years || []);
    } else {
      // ✅ Fetch data only if not available in state
      getCompleteData(setSpareModels, setSpareBrand, setSpareCategory);
      getItems(setRegion);
    }
  }, [location.state]);

  const filters = {
    brandId: searchParams.get("brandId"),
    modelId: searchParams.get("modelId"),
    year: searchParams.get("year"),
    regionId: searchParams.get("regionId"),
  };

  useEffect(() => {
    if (
      filters.brandId ||
      filters.modelId ||
      filters.year ||
      filters.regionId
    ) {
      searchPart(filters).then((fetchedParts) => {
        console.log("Fetched parts:", fetchedParts);
        setParts(fetchedParts); // ✅ Set parts state
      });
    }
  }, [location.search]);

  const getBrandName = (brandId) =>
    spareBrand.find((b) => b._id === brandId)?.name || "Unknown Brand";

  const getModelName = (modelId) =>
    spareModels.find((m) => m._id === modelId)?.name || "Unknown Model";

  const getRegionName = (regionId) =>
    region.find((m) => m._id === regionId)?.name || "Unknown Region";

  const getCategoryName = (categoryId) =>
    spareCategory.find((m) => m._id === categoryId)?.name || "Unknown Category";

  return (
    <div>
      <Header />
      <section id="inner-banner">
        <div class="container">
          <div class="bnr-div">
            <SeachSection />
          </div>

          <div class="row mt-5">
            <Advancedfilter />

            <div class="col-lg-9">
              <div class="table-responsive mt-3">
                <table class="table product-table">
                  <tbody>
                    <tr>
                      <th class="align-middle" width="70">
                        Name
                      </th>
                      <th class="align-middle" width="70">
                        Brand
                      </th>
                      <th class="align-middle" width="130">
                        Model designation
                      </th>
                      <th class="align-middle" width="70">
                        Engine
                      </th>
                      <th class="align-middle" width="70">
                        Region
                      </th>
                      <th class="align-middle" width="140">
                        Transmission{" "}
                      </th>
                      <th class="align-middle" width="60">
                        Year
                      </th>
                    </tr>
                    {parts?.length != 0 ? (
                      parts.map((product, index) => (
                        <tr>
                          <td class="align-middle" width="70">
                            {toTitleCase(product?.name)}
                          </td>
                          <td class="align-middle" width="70">
                            {toTitleCase(getBrandName(product?.brandId))}
                          </td>
                          <td class="align-middle" width="130">
                            {toTitleCase(getModelName(product?.modelId))}
                          </td>
                          <td class="align-middle" width="70">
                            {toTitleCase(product?.engine)}
                          </td>
                          <td class="align-middle" width="70">
                            {toTitleCase(getRegionName(product?.regionId))}
                          </td>
                          <td class="align-middle" width="140">
                            {toTitleCase(product.transmissionType)}
                          </td>
                          <td class="align-middle" width="60">
                            {product.year}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="7"
                          rowSpan="5"
                          className="text-center py-4"
                        >
                          {" "}
                          <NoData />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* <div class="row product-list gutter-7">
                          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-4 col-lg-4"  >
                            <Link key={index} to={`/productlist`}
                              state={{ parts, spareCategory, spareBrand, spareModels, region, years }}
                              className="prod-link block h-full">
                              <div className="prod-div bg-white p-4 rounded-lg shadow-lg flex flex-col items-center hover:shadow-xl transition h-full">
                                <img src={product.image} loading="lazy" className="w-16 h-16 object-contain" />
                                <h6 className="mt-2 text-center text-gray-800 font-semibold">{getCategoryName(product.categoryId)}</h6>
                              </div>
                            </Link>
                          </div>
                        </div>  */}
            </div>

            {/* <select
                      className="form-control"
                      aria-label="Default select example"
                    >
                      <option selected="" disabled="">
                        Region
                      </option>
                      {regionOptions.map((region) => (
                        <option key={region._id} value={region._id}>
                          {region.name}
                        </option>
                      ))}
                    </select>

                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Steering
                      </option>
                      {steeringOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Body type
                      </option>

                      {bodyTypeOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Transmission type
                      </option>
                      {transmissionOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Body
                      </option>
                      {bodyTypeOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Modification
                      </option>
                      {modificationOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Engine
                      </option>
                      {engineOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Engine code
                      </option>
                      {engineCodeOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select>
                    <select class="form-control" aria-label="Default select example">
                      <option selected="" disabled="">
                        Grade
                      </option>
                      {gradeOptions.map((name, index) => (
                        <option key={index} value={name}>
                          {name}
                        </option>
                      ))}
                    </select> */}
          </div>
        </div>
      </section>
    </div>
  );
};
